import { Button } from '../../index';
import classes from './footer.module.scss';

type FooterProps = {
  previousLabel?: string,
  acceptLabel: string,
  rejectLabel: string,

  footerLeftSection?: JSX.Element,

  isLoading?: boolean;
  isPreviousDisable?: boolean,
  isAcceptDisable?: boolean,

  onPrevious?: () => void,
  onAccept?: () => void,
  onReject?: () => void,
};

const Footer = (props: FooterProps): JSX.Element =>
  <div className={classes.root}>
    <div className={classes.footerLeft}>
      {props.onPrevious
        ? <Button variant="secondary" onClick={props.onReject} id="registration-form-cancel-button">{props.rejectLabel}</Button>
        : props.footerLeftSection}
    </div>
    <div className={classes.footerRight}>
      {props.onPrevious
        ? <Button onClick={props.onPrevious} disabled={props.isPreviousDisable} id="registration-form-back-button">{props.previousLabel}</Button>
        : <Button variant="secondary" onClick={props.onReject} id="registration-form-cancel-button">{props.rejectLabel}</Button>}
      <Button
        id="registration-form-submit-button"
        loading={props.isLoading}
        disabled={props.isAcceptDisable}
        rootClassName={classes.accept}
        onClick={props.onAccept}
      >
          {props.acceptLabel}
      </Button>
    </div>
  </div>

Footer.defaultProps = {
  isPreviousDisable: false,
  isAcceptDisable: false,

  previousLabel: 'Previous',
  acceptLabel: 'Submit',
  rejectLabel: 'Cancel',

  onPrevious: undefined,
  onAccept: undefined,
  onReject: undefined,
}

export { Footer, FooterProps };
